module.exports = __webpack_public_path__ + "static/img/IMG_20241023_141838.1b1736d4.jpg";